import { FORMAT_DATE_BACK, formatDate, getPreviousDate, isEmpty } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { commonFiltersValue } from "@signals"
import { stockChangesCurrentPeriod, stockChangesEndDate, StockChangesPriceEvolutionFilters, StockChangesStockEvolutionFilters } from "../../@signals"


export default function useStockChangesShowEvolution(siteID, productID, skuID, externalSeller) {
    const newFilters = commonFiltersValue.peek()

	const handleClickShowPriceEvolution = (filters) => {
		filters.value = {}
		setTimeout(() => {
            stockChangesEndDate.value = newFilters.currentSingleDate
			let startDate = formatDate(getPreviousDate({days: 6}, stockChangesEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

			stockChangesCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

			filters.value = {
				...commonFiltersValue.peek(),
				startDate: startDate,
				endDate: stockChangesEndDate.value,
				productID: productID,
				retailer: [siteID],
				sku: [skuID],
				externalSeller: externalSeller,
			}
		}, 0.1)
	}

	return {
		isOpenPriceEvolutionChart: !isEmpty(StockChangesPriceEvolutionFilters.value) &&
			StockChangesPriceEvolutionFilters.value['productID'] === productID &&
			StockChangesPriceEvolutionFilters.value['siteID'] === siteID &&
			StockChangesPriceEvolutionFilters.value['externalSeller'] === externalSeller,
		isOpenStockEvolutionChart: !isEmpty(StockChangesStockEvolutionFilters.value) && StockChangesStockEvolutionFilters.value['productID'][0] === productID,
		
		handleClickShowPriceEvolution
	}
}